﻿<template>
  <PmwModal
    v-bind="$attrs"
    buttonAlignment="end"
    confirmButtonText="Salvar flutuação"
    cancelButtonText="Voltar para edição"
    width="1234px"
    class="modal-preview-save-data"
    @input="$emit('input', $event)"
  >
    <div class="content-grid">
      <!-- CONTEÚDO DA ESQUERDA -->
      <div class="content-grid__left">
        <SidebarBlock class="sidebar-block__first">
          <!-- TODO validar se este texto é fixo -->
          <PmwHeading
            :size="'heading-20'"
            class="sidebar-block--title"
            weight="medium"
            >Desconto Básico</PmwHeading
          >

          <!-- DESCRIÇÃO DA TARIFA -->
          <PmwParagraph
            class="rate-description"
            size="paragraph-40"
            weight="light"
          >
            Enquanto aprecia o resort, relaxe na varanda destes apartamentos de
            41 metros quadrados. Os hóspedes certamente ficarão encantados com a
            vista do resort ou das piscinas ou jardins ao ar livre a partir de
            sua varanda.
          </PmwParagraph>
        </SidebarBlock>

        <SidebarBlock>
          <!-- DEMAIS ITENS -->
          <PmwParagraph
            class="sidebar-block--title"
            size="paragraph-60"
            weight="medium"
          >
            Demais itens
          </PmwParagraph>

          <!-- TODO conferir com a Gabi e ux qual será o comportamento nessa parte -->
          <PmwParagraph
            class="content-grid--policies"
            size="paragraph-40"
            weight="light"
          >
            Política e restrições da tarifa
            <br /><strong>Padrão do hotel</strong>&nbsp;<PmwLink
              elm="button"
              @click="loadHotelPolicy"
              >ver política</PmwLink
            >
          </PmwParagraph>

          <ResumeCheckItem checked>Modalidade de cobrança</ResumeCheckItem>
          <ResumeCheckItem checked>Precificação</ResumeCheckItem>
          <ResumeCheckItem checked>Pensão</ResumeCheckItem>
          <ResumeCheckItem>Valor por acomodação</ResumeCheckItem>
          <ResumeCheckItem>Acrescimo por pax</ResumeCheckItem>
        </SidebarBlock>
      </div>

      <!-- CONTEÚDO DA DIREITA -->
      <div class="content-grid__right">
        <!-- NOMES DA TARIFA -->
        <div class="lb-grid-row rate-names">
          <!-- NOME INTERNO -->
          <ContentBlock title="Qual o nome dessa tarifa?" class="names-list">
            <LangRateName
              :lang="'pt-br'"
              text="Desconto Black Friday"
              class="lang-name"
            />
            <LangRateName
              :lang="'en'"
              text="Black Friday Discount"
              class="lang-name"
            />
            <LangRateName
              :lang="'es'"
              text="Descuento Black Friday"
              class="lang-name"
            />
          </ContentBlock>

          <!-- NOME EXTERNO -->
          <ContentBlock
            title="Como vai aparecer para o usuário?"
            class="names-list"
          >
            <LangRateName
              :lang="'pt-br'"
              text="Desconto Black Friday"
              class="lang-name"
            />
            <LangRateName
              :lang="'en'"
              text="Black Friday Discount"
              class="lang-name"
            />
            <LangRateName
              :lang="'es'"
              text="Descuento Black Friday"
              class="lang-name"
            />
          </ContentBlock>
        </div>

        <!-- DIFERENCIAIS -->
        <div class="lb-grid-row differentials">
          <ContentBlock title="Diferenciais">
            <div class="differentials-list">
              <PmwParagraph><span>•</span> Remarque com taxas</PmwParagraph>
              <PmwParagraph><span>•</span> All inclusive</PmwParagraph>
              <PmwParagraph><span>•</span> Decoração romântica</PmwParagraph>
              <PmwParagraph><span>•</span> Remarque com taxas</PmwParagraph>
              <PmwParagraph><span>•</span> All inclusive</PmwParagraph>
              <PmwParagraph><span>•</span> Decoração romântica</PmwParagraph>
              <PmwParagraph><span>•</span> Remarque com taxas</PmwParagraph>
              <PmwParagraph><span>•</span> All inclusive</PmwParagraph>
              <PmwParagraph><span>•</span> Decoração romântica</PmwParagraph>
              <PmwParagraph><span>•</span> Remarque com taxas</PmwParagraph>
              <PmwParagraph><span>•</span> All inclusive</PmwParagraph>
              <PmwParagraph><span>•</span> Decoração romântica</PmwParagraph>
              <PmwParagraph><span>•</span> Remarque com taxas</PmwParagraph>
              <PmwParagraph><span>•</span> All inclusive</PmwParagraph>
              <PmwParagraph><span>•</span> Decoração romântica</PmwParagraph>
              <PmwParagraph><span>•</span> Remarque com taxas</PmwParagraph>
              <PmwParagraph><span>•</span> All inclusive</PmwParagraph>
              <PmwParagraph><span>•</span> Decoração romântica</PmwParagraph>
            </div>
          </ContentBlock>
        </div>

        <!-- PERÍODOS DE DISPONIBILIDADE -->
        <div class="lb-grid-row disponibility-time">
          <!-- RESERVA -->
          <ContentBlock
            title="Quando essa tarifa vai estar disponível para RESERVA?"
            icon="calendar-light"
            class="reservation"
            content-padding
          >
            <DateRangeText
              :dates="{ start: new Date(), end: new Date(2023, 11, 1) }"
            />
          </ContentBlock>

          <!-- HOSPEDAGEM -->
          <ContentBlock
            title="Quando essa tarifa vai estar disponível para HOSPEDAGEM?"
            icon="calendar-light"
            class="hosting"
            content-padding
          >
            <DateRangeText
              :dates="{ start: new Date(), end: new Date(2023, 11, 1) }"
            />
          </ContentBlock>
        </div>

        <!-- BLACKOUT -->
        <div class="lb-grid-row blackout">
          <ContentBlock
            title="Qual é o Blackout?"
            icon="x-circle"
            class="reservation"
            content-padding
          >
            <DateRangeText
              :dates="{ start: new Date(), end: new Date(2023, 11, 1) }"
            />
          </ContentBlock>
        </div>

        <!-- PAGAMENTO -->
        <div class="lb-grid-row payment">
          <ContentBlock
            title="Como pode ser paga essa flutuação?"
            icon="percent-circle"
            class="reservation"
            content-padding
          >
            VISA(até 10x) VISA(até 10x - min. R$ 50,00)
          </ContentBlock>
        </div>
      </div>
    </div>
  </PmwModal>
</template>

<script>
import PmwModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwModal'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import ContentBlock from './ContentBlock.vue'
import LangRateName from './LangRateName.vue'
import DateRangeText from './DateRangeText.vue'
import ResumeCheckItem from './ResumeCheckItem.vue'
import PmwLink from '@/components/_base/elements/PmwLink.vue'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'

export default {
  name: 'ModalPreviewSaveData',

  components: {
    PmwModal,
    PmwHeading,
    PmwParagraph,
    LangRateName,
    ContentBlock,
    DateRangeText,
    ResumeCheckItem,
    PmwLink,
    SidebarBlock
  },

  data() {
    return {
      showHotelPolicy: false
    }
  },

  methods: {
    loadHotelPolicy() {}
  }
}
</script>

<style lang="scss" scoped>
.modal-preview-save-data {
  .sidebar-block {
    &__first {
      padding-top: 0;
    }

    &--title {
      margin-bottom: pmw-space(2);
    }
  }

  .content-grid {
    display: grid;
    grid-template-columns: 300px 1fr;
  }

  .content-grid {
    &__left {
      padding-right: pmw-space(5);
    }

    &__right {
      padding-left: pmw-space(5);
      border-left: 1px solid pmw-colors('grey-20');
    }

    &--policies {
      margin-bottom: pmw-space(2);
      line-height: 1.4;
    }
  }

  .lb-grid-row {
    & + .lb-grid-row {
      margin-top: pmw-space(4);
    }
  }

  .rate-description {
    line-height: 2;
  }

  .rate-names,
  .disponibility-time {
    display: flex;
    gap: 0 pmw-space(5);

    .lang-name {
      margin-top: pmw-space(0.5);
    }
  }

  .differentials-list {
    display: flex;
    flex-wrap: wrap;
    gap: pmw-space(2);

    span {
      font-size: 24px;
      vertical-align: middle;
    }
  }
}
</style>
